export default "__VITE_PUBLIC_ASSET__4122acd0__"